import { useCartItemCache } from '@/features/pos/components/Cart/hooks/useCartItemCache'
import { ConfigurableProductQuery } from '@/features/pos/components/ProductCatalog/queries/configurableProduct'
import { ConfigurableProduct } from '@/features/pos/components/ProductConfigurationModal/types'
import { transformProductToConfigurable } from '@/features/pos/components/ProductConfigurationModal/utils/transforms'
import { useHandleQueryErrorWithToast } from '@/features/pos/hooks/useHandleQueryErrorWithToast'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useCartItemConfigurableProduct = (
    itemId: string | undefined,
    productId: string | undefined
): ConfigurableProduct | undefined => {
    const { data, error, loading } = useQuery(ConfigurableProductQuery, {
        variables: { id: productId! },
        skip: !productId,
        fetchPolicy: 'cache-and-network',
    })

    useHandleQueryErrorWithToast(error, loading)

    const cartItem = useCartItemCache(itemId)

    const { t } = useTranslation()

    return useMemo(() => {
        if (!data?.product || !cartItem) return undefined

        return transformProductToConfigurable(data.product, t, cartItem)
    }, [data?.product, cartItem, t])
}
